// extracted by mini-css-extract-plugin
module.exports = {"root":"Navbar-module--root--2SpmK","navbar":"Navbar-module--navbar--2S7c_","items":"Navbar-module--items--1Ju5Y","active":"Navbar-module--active--HzQfF"};